import { createAsyncThunk } from '@reduxjs/toolkit';
import estimateApi from '~/apis/estimate';
import {
  CREATE_PRICE_COMPONENT,
  EDIT_PRICE_COMPONENT,
  GET_PRICE_COMPONENT,
  GET_PRICE_COMPONENTS,
} from '~/utils/constants/actionType';
import { IParamsGetPriceComponent, IPriceComponent, IResponseGetPriceComponentList } from '~/utils/interface/estimate';

export const handleGetPriceComponents = createAsyncThunk<IResponseGetPriceComponentList, IParamsGetPriceComponent>(
  GET_PRICE_COMPONENTS,
  async (params: IParamsGetPriceComponent = {}, { rejectWithValue }) => {
    try {
      const res = await estimateApi.getPriceComponentList(params);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetPriceComponent = createAsyncThunk<IPriceComponent, string>(
  GET_PRICE_COMPONENT,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await estimateApi.getPriceComponent(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreatePriceComponent = createAsyncThunk<IPriceComponent, IPriceComponent>(
  CREATE_PRICE_COMPONENT,
  async (data: IPriceComponent, { rejectWithValue }) => {
    try {
      const res = await estimateApi.createPriceComponent(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleEditPriceComponent = createAsyncThunk<IPriceComponent, { id: string; params: IPriceComponent }>(
  EDIT_PRICE_COMPONENT,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await estimateApi.updatePriceComponent(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
